document.addEventListener('alpine:init', () => {
    Alpine.data('counters', () => ({
        visible: false,
        startTime: null,

        numberWithCommas(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        startCount(){
            let currentTime = Date.now();

            const step = (currentTime) => {

                if (!this.startTime) {
                    this.startTime = currentTime ;
                }

                const progress = Math.min((currentTime  - this.startTime) / 1500, 1);

                let number = parseFloat(this.$refs.number.dataset.counterNumber);
                const hasDecimal = (number - Math.floor(number)) !== 0;
                let countedNumber;

                if (hasDecimal) {
                    countedNumber = ((progress * number).toFixed(1));
                } else {
                    countedNumber = Math.floor(progress * number);
                }

                this.$refs.number.innerHTML = this.numberWithCommas(countedNumber);

                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
                else{
                    window.cancelAnimationFrame(window.requestAnimationFrame(step));
                }
            };

            window.requestAnimationFrame(step);
        }
    }))
});
